import { useState } from 'react';

const DEFAULT_PAGE_SIZE = 10;

/* Client-side pagination. None of this backend's documented GET list
   endpoints (README §4) take a page/limit/offset/cursor param or return
   next/previous metadata — every worked example in BrandonUserStoryAPI.md
   is a flat { count, <items> } with the whole list in one response,
   confirmed across every list endpoint we call. So there's nothing to
   paginate over the wire yet; this slices whatever's already been fetched
   into db instead, purely for the table's own rendering. If the backend
   ever adds real server-side paging, only the fetch in IcibAdminContext
   needs to change — every call site here already just hands this hook a
   plain array and gets a page-sized slice back. */
export function usePagination(items, pageSize = DEFAULT_PAGE_SIZE) {
  const [requestedPage, setPage] = useState(1);
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  // Clamp rather than reset via effect — if a filter shrinks the list
  // mid-browse the view falls back to the last real page, and paging
  // back out (more results again) picks up where the user actually was.
  const page = Math.min(requestedPage, pageCount);
  const start = (page - 1) * pageSize;
  return { page, setPage, pageCount, pageItems: items.slice(start, start + pageSize), total: items.length };
}

export default function Pagination({ page, setPage, pageCount, total }) {
  if (pageCount <= 1) return null;
  return (
    <div className="btn-row" style={{ justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
      <button type="button" className="btn sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>‹ Prev</button>
      <span className="mono dim" style={{ fontSize: 11.5 }}>Page {page} of {pageCount} · {total} total</span>
      <button type="button" className="btn sm" disabled={page >= pageCount} onClick={() => setPage((p) => p + 1)}>Next ›</button>
    </div>
  );
}
